export default function Philosophy() {
  return (
    <section id="philosophy" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 items-center">
          {/* 左側画像エリア */}
          <div className="md:col-span-2">
            <div className="relative">
              <div className="inline-block mb-6 px-5 py-2 border-2 border-gray-300 rounded-full bg-white/80">
                <span className="text-sm font-medium text-gray-600" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>Our Philosophy</span>
              </div>
              <div className="rounded-3xl overflow-hidden shadow-lg">
                <img
                  src="https://public.readdy.ai/ai/img_res/fb9e134fa00789c506f7dbabe96141e8.jpg"
                  alt="スタッフと利用者様の温かい会話"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* 右側テキストエリア */}
          <div className="md:col-span-3">
            <h3 className="text-4xl md:text-5xl font-black text-amber-900 leading-tight mb-6" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
              私たちは、ご利用者様を<br />
              家族のように大切にします
            </h3>
            <p className="text-base text-gray-600 leading-loose mb-8 font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              まごころサービスでは、一人ひとりのお客様に寄り添い、その方らしい生活を支えることを大切にしています。介護保険外のサービスだからこそ、柔軟で心のこもった対応が可能です。
            </p>
            <p className="text-base text-gray-600 leading-loose mb-10 font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              専門スタッフが、日々の暮らしの中で感じる小さな不安や悩みにも耳を傾け、温かくサポートいたします。ご利用者様とそのご家族が、安心して笑顔で過ごせる毎日をお届けすることが、私たちの使命です。
            </p>
            <a 
              href="#contact" 
              className="inline-flex items-center gap-2 bg-amber-900 text-white px-8 py-3 rounded-full text-sm font-semibold hover:bg-amber-800 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              お問い合わせはこちら
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
